export class ARRIVAL_STATE {
  static NotArrived = 0;
  static ArrivedAndRejected = 5;
  static Arrived = 10;
  static Seated = 15;
  static Delayed = 80;
  static NoShow = 90;

  static PartialArrival = 12 // Only used in frontend;

  static nameof(state) {
    switch (state) {
      case ARRIVAL_STATE.NotArrived: {
        return 'Not arrived';
      }
      case ARRIVAL_STATE.Arrived: {
        return 'Arrived';
      }
      case ARRIVAL_STATE.Seated: {
        return 'Seated';
      }
      case ARRIVAL_STATE.Delayed: {
        return 'Delayed';
      }
      case ARRIVAL_STATE.NoShow: {
        return 'No show';
      }
      case ARRIVAL_STATE.ArrivedAndRejected: {
        return 'Rejected on arrival';
      }
      case ARRIVAL_STATE.PartialArrival: {
        return 'Partial arrival';
      }
    }
  }

  static colorof(state) {
    switch (state) {
      case ARRIVAL_STATE.NotArrived: {
        return 'red';
      }
      case ARRIVAL_STATE.Arrived: {
        return 'black';
      }
      case ARRIVAL_STATE.Seated: {
        return 'black';
      }
      case ARRIVAL_STATE.Delayed: {
        return 'pink';
      }
      case ARRIVAL_STATE.NoShow: {
        return 'black';
      }
      case ARRIVAL_STATE.ArrivedAndRejected: {
        return 'black';
      }
      case ARRIVAL_STATE.PartialArrival: {
        return 'black';
      }
    }
  }

  static iconof(state) {
    switch (state) {
      case ARRIVAL_STATE.NotArrived: {
        return 'CircleIcon';
      }
      case ARRIVAL_STATE.Arrived: {
        return 'CheckCircleIcon';
      }
   
      case ARRIVAL_STATE.Seated: {
        return 'AnchorIcon';
      }
      case ARRIVAL_STATE.Delayed: {
        return 'ClockIcon';
      }
      case ARRIVAL_STATE.NoShow: {
        return 'SlashIcon';
      }
      case ARRIVAL_STATE.ArrivedAndRejected: {
        return 'XCircleIcon';
      }
      case ARRIVAL_STATE.PartialArrival: {
        return 'UsersIcon';
      }
    }
  }

  static getAll() {
    return [ARRIVAL_STATE.NotArrived, ARRIVAL_STATE.Arrived, ARRIVAL_STATE.PartialArrival,  ARRIVAL_STATE.Seated, ARRIVAL_STATE.Delayed, ARRIVAL_STATE.NoShow, ARRIVAL_STATE.ArrivedAndRejected];
  }
}
